/* =============================================================
   THEME.JS — Main JavaScript for custom Shopify theme
   ============================================================= */

document.addEventListener('DOMContentLoaded', function () {

  // ---- Header: Sticky scroll effect ----
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // ---- Mega Menu ----
  const navLinks = document.querySelectorAll('[data-mega-menu-trigger]');
  const megaMenus = document.querySelectorAll('.mega-menu');
  let activeMenu = null;
  let closeTimeout = null;

  function openMenu(menuId) {
    clearTimeout(closeTimeout);
    megaMenus.forEach(m => m.classList.remove('is-open'));
    const menu = document.querySelector(`[data-mega-menu="${menuId}"]`);
    if (menu) {
      menu.classList.add('is-open');
      activeMenu = menu;
    }
  }

  function closeMenus() {
    closeTimeout = setTimeout(() => {
      megaMenus.forEach(m => m.classList.remove('is-open'));
      activeMenu = null;
    }, 150);
  }

  navLinks.forEach(link => {
    const menuId = link.dataset.megaMenuTrigger;
    link.addEventListener('mouseenter', () => openMenu(menuId));
    link.addEventListener('mouseleave', closeMenus);
  });

  megaMenus.forEach(menu => {
    menu.addEventListener('mouseenter', () => clearTimeout(closeTimeout));
    menu.addEventListener('mouseleave', closeMenus);
  });

  // Close on click outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-mega-menu-trigger]') && !e.target.closest('.mega-menu')) {
      megaMenus.forEach(m => m.classList.remove('is-open'));
    }
  });

  // ---- Mobile Menu ----
  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileMenuClose = document.querySelector('[data-mobile-menu-close]');

  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener('click', () => {
      mobileMenu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileMenuClose && mobileMenu) {
    mobileMenuClose.addEventListener('click', () => {
      mobileMenu.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  // ---- Product Card: Image swap on hover (already CSS, but add touch support) ----
  const productCards = document.querySelectorAll('.product-card');
  productCards.forEach(card => {
    card.addEventListener('touchstart', () => {
      card.classList.toggle('is-hovered');
    }, { passive: true });
  });

  // ---- Newsletter Form ----
  const newsletterForm = document.querySelector('.newsletter__form-el');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = newsletterForm.querySelector('input[type="email"]').value;
      const btn = newsletterForm.querySelector('.newsletter__submit');
      btn.textContent = 'Subscribing...';
      // Shopify handles newsletter via form action — this is for UX feedback
      setTimeout(() => {
        btn.textContent = 'Thank you!';
      }, 800);
    });
  }

  // ---- Lazy load images ----
  if ('IntersectionObserver' in window) {
    const lazyImages = document.querySelectorAll('img[data-src]');
    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          imageObserver.unobserve(img);
        }
      });
    }, { rootMargin: '200px 0px' });

    lazyImages.forEach(img => imageObserver.observe(img));
  }

  // ---- Scroll-reveal animations ----
  if ('IntersectionObserver' in window) {
    const revealEls = document.querySelectorAll('[data-reveal]');
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    revealEls.forEach(el => revealObserver.observe(el));
  }



  // ---- Search Overlay (Daily Paper style) ----
  const searchToggleBtn = document.querySelector('[data-search-toggle]');
  const searchOverlay   = document.getElementById('search-overlay');
  const searchInput     = document.getElementById('search-overlay-input');
  const searchCloseBtns = document.querySelectorAll('[data-search-close]');

  function openSearch() {
    if (!searchOverlay) return;
    // Position overlay to exactly cover the sticky header (accounts for announcement bar)
    const siteHeader = document.querySelector('.site-header');
    if (siteHeader) {
      const rect = siteHeader.getBoundingClientRect();
      searchOverlay.style.top = rect.top + 'px';
      searchOverlay.style.height = rect.height + 'px';
    }
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    if (searchInput) setTimeout(() => searchInput.focus(), 50);
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    if (searchInput) searchInput.value = '';
  }

  // Event delegation — reliable regardless of DOM render timing
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-toggle]')) openSearch();
    if (e.target.closest('[data-search-close]')) closeSearch();
  });

  // Close on Escape key
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('is-open')) {
      closeSearch();
    }
  });

});